export default __webpack_public_path__ + "static/media/processSectionSvg.824cbbd5.svg";